import { render } from "./ModalCompartirNoticia.vue?vue&type=template&id=248b8b10"
import script from "./ModalCompartirNoticia.vue?vue&type=script&lang=js"
export * from "./ModalCompartirNoticia.vue?vue&type=script&lang=js"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__